﻿import { OutputField } from "@models/configurators/output-fields/output-field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { eOutputFieldType } from "@models/enums";
import { IExcelSheetField } from "@models/entity-models";
import { KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";

@KboOutputField(CToken.ExcelSheetField, eOutputFieldType.excelSheet)
export class ExcelSheetField extends OutputField implements IExcelSheetField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public deleted: boolean;
    public tryCalculateFormula: boolean;
    public autoFitColumns: boolean;
    public autoFitRows: boolean;
}
